import type { Mobility_Runs_Bool_Exp } from '@gql/base-types';

import { customerScopeFilter, windowFilter } from '@features/products/counts/countFilters';
import type { CountWindow } from '@features/products/counts/productCounts';

/** Matches the column the tab filters on. */
export const PARTSDELIVERY_WINDOW_COLUMN = 'departure_time';

export const buildPartsDeliveryCountsVariables = ({ customerIds, window }: { customerIds: number[]; window: CountWindow }) => ({
  scope: customerScopeFilter<Mobility_Runs_Bool_Exp>(customerIds),
  window: windowFilter<Mobility_Runs_Bool_Exp>(PARTSDELIVERY_WINDOW_COLUMN, window),
});
